import API from "@/API";
import dataTableCreator from "@/store/creators/dataTable";

const SET_PROFESSIONAL = "SET_PROFESSIONAL";
const SET_CHANNEL_TYPE = "SET_CHANNEL_TYPE";

const state = {
  professional: null,
  channelType: "",
  headers: [
    { text: "Tipo", value: "type" },
    { text: "Criada em", value: "created_at", align: "center" },
    { text: "De", value: "from" },
    { text: "Para", value: "to" },
    { text: "Status", value: "status", align: "center" },
    { text: "Valor", value: "amount", align: "center" },
    { value: "data-table-expand" }
  ]
};

const actions = {
  setProfessional({ state, commit, dispatch }, professional) {
    if (state.professional === professional) return;
    commit("SET_PROFESSIONAL", professional);
    dispatch("resetDataTable");
  },

  async getItems({ dispatch }) {
    dispatch("startLoader");

    try {
      let results = await API.Transfers.getList();
      dispatch("setTotalItems", results.totalItems);
      dispatch("setItems", results.data);
    } catch (e) {
      dispatch("clearItems");
      dispatch("stopLoader");
      throw e;
    }

    dispatch("stopLoader");
  },

  setChannelType({ state, commit, dispatch }, channelType) {
    if (state.channelType === channelType) return;
    commit("SET_CHANNEL_TYPE", channelType);
    dispatch("resetDataTable");
  }
};

const mutations = {
  [SET_PROFESSIONAL](state, professional) {
    state.professional = professional;
  },
  [SET_CHANNEL_TYPE](state, channelType) {
    state.channelType = channelType;
  }
};

export default {
  namespaced: true,
  state: { ...dataTableCreator.state, ...state },
  actions: { ...dataTableCreator.actions, ...actions },
  mutations: { ...dataTableCreator.mutations, ...mutations },
  getters: dataTableCreator.getters
};



// WEBPACK FOOTER //
// ./src/store/modules/transfers/list.js